module.exports = __webpack_public_path__ + "static/media/yabadoo-icon-512x512.a423abc6.png";